import React from 'react'
import commonStyles from "../../Shared/commonStyles.module.css";
import problemStyles from "./Problem.module.css";

function Problem() {
  return (
        <section className={`${commonStyles.section} ${problemStyles.problem} ${commonStyles.reveal}`}>
      <div className={commonStyles.container}>
        <div className={problemStyles.problemBox}>
          <h2>Short on time, but still want your gift to feel special?</h2>
          <p>Choosing the right items, personalising them, and coordinating delivery can be overwhelming. Match Hampers makes gifting simple while keeping the result personal and premium.</p>
        </div>
      </div>
    </section>
  )
}

export default Problem